// removed by extract-text-webpack-plugin
module.exports = {"coloredInfo":"xk6hmjtHueoCa4nfa_v1-","expireDate":"_1DXk_W6i_T45d48-kII86K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemSystemInfo/AlbumItemSystemInfo.scss
// module id = 1240
// module chunks = 1